@for (page of pagesArr; track page) {
  <button
    [ngClass]="{'active': page === activePage}"
    (click)="gotToPage(page)"
    [attr.data-cy]="'pagination-page-' + page"
    >
    {{ page }}
  </button>
}
